import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Layout, QRCode, Space } from "antd";
import { Link } from "react-router-dom";
import { Image } from "antd";
import Headers from "../frame/headers.component";
import Footers from "../frame/footers.component";
import AuthService from "../../services/auth.service";
import { API_BASE_URL } from "../../services/apiConfig";
import Stomp from 'stompjs';
import SockJS from 'sockjs-client';
import axios from "axios";
import {API_BASE_URL_ISSUER} from "../../services/apiConfig";
const Waitinput: React.FC = () => {

  const { clubseq } = useParams();


  useEffect(() => {
    // console.log("(Wait) DNet 토큰 파라미터  >>>> clubseq ", clubseq);
  }, []);

  const [did, setDid] = useState<string | null>(null);
  const [clubNumber, setClubNumber] = useState<string | null>(null);
  const [clubName, setClubName] = useState<string | null>(null);
  const [memberid, setmemberid] = useState<string | null>(null);

  const [tokendata, settokendata] = useState<string | null>(null);
  const [isConditionTrue, setIsConditionTrue] = useState<string | null>("true");
  const [contentLength, setcontentLength] = useState<number>(0);
  const [selectedDeviceName, setselectedDeviceName] = useState<any>("");
  const [selectdeviceid, setselectdeviceid] = useState<any>("");
  const [selectmemberidsoket, setselectmemberidsoket] = useState<any>("");
  const [qrdata, setqrdata] = useState<any>("");

  
  const [isQrmode, setisQrmode] = useState(false);


  // useEffect(() => {
  //   const interval = setInterval(async () => {
  //     const handleWaitcountChange = async () => {
  //       fetchWaitMemberDataAPI();

  //     };

  //     handleWaitcountChange();
  //   }, 1500);

  //   return () => clearInterval(interval);
  // }, [clubNumber,contentLength]);

  useEffect(() => {
    if (tokendata !== null) {
      fetch(
        `${API_BASE_URL}/club/list/my/issuer?page=0&size=2000000&sort=clubSeq,desc`,
        {
          headers: {
            Authorization: `Bearer ${tokendata}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.data && data.data.content) {
            const extractedInfo = data.data.content.map((club: any) => ({
              club_seq: club.clubSeq,
              club_name: club.clubName,
              club_category_seq: club.clubCategory.categoryCode,
              start_date: club.startDate,
              end_date: club.endDate,
            }));
            console.log("리스트" + JSON.stringify(extractedInfo, null, 2));
            console.log("찾을값 : " + clubseq);

            // clubseq를 숫자로 변환하여 사용
            const filteredInfo = extractedInfo.filter(
              (item: any) => item.club_seq === (clubseq ? parseInt(clubseq) : 0)
            );

            // 찾은 클럽명 출력
            if (filteredInfo.length > 0) {
              console.log("찾은 클럽명 : " + filteredInfo[0].club_name);
              setClubName(filteredInfo[0].club_name)

            } else {
              console.log("해당 club_seq를 가진 클럽을 찾을 수 없습니다.");
            }

          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [tokendata]);
  const fetchWaitMemberDataAPI = async () => {
    if (tokendata != null) {
      try {
        const currentDate = new Date();
        const localOffset = currentDate.getTimezoneOffset() * 60000; // offset in milliseconds
        const correctedDate = new Date(currentDate.getTime() - localOffset);

        const formattedDate = correctedDate.toISOString().split("T")[0];
        // console.log("조회!")
        console.log(`${API_BASE_URL}/club/agent/reception/waiting/list/department/${clubseq}/${formattedDate}/${selectedDeviceName}?page=0&size=2000&sort=agentClubWaitingSeq,desc`)
        const response = await fetch(
          `${API_BASE_URL}/club/agent/reception/waiting/list/department/${clubseq}/${formattedDate}/${selectedDeviceName}?page=0&size=2000&sort=agentClubWaitingSeq,desc`,
          {
            method: "GET",

            headers: {
              Authorization: `Bearer ${tokendata}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        // console.log("출력 : " + JSON.stringify(data, null, 2));
        const trueFlagCount = data.data.content.filter((item: any) => item.flag === true).length;

        // console.log("개수확인 : " + trueFlagCount)


        if (data.data.content.length !== 0) {
          setcontentLength(trueFlagCount);
        }

        // console.log("(Waitinput) flag1_ Data from API:", data);
      } catch (error) {
        // console.error("(ExcelUpload) Error fetching data:", error);
      }
    }


  };



  useEffect(() => {
    // console.log("아이디있음")
    // console.log("클럽  " + selectedClubInfo?.club_seq)

    let userId = memberid;


    const socket = new SockJS(API_BASE_URL + '/ws');
    const stompClient = Stomp.over(socket);
    const headers = { 'sender': selectmemberidsoket, 'admin': 'true' };
    stompClient.connect(headers, function (frame) {

      console.log("연결성공");

      stompClient.subscribe('/queue/waiting-message/' + userId, (message) => {
        try {
          console.log("클럽번호 : " + clubNumber);
          fetchWaitMemberDataAPI();
        } catch (error) {
          console.error('Error parsing message:', error);
        }
      });
    }, (error) => {
      console.error('Error during WebSocket connection:', error);
    });


  }, []);
  useEffect(() => {
    const updateQRData = async () => {
      if(did!==null){
        try {
          const selectDeviceId = localStorage.getItem("selectdeviceid");
          if (selectDeviceId !== null) {
            const startsWithTmpDevice = selectDeviceId.startsWith("tmp_device");
            if (startsWithTmpDevice) {
              setisQrmode(true);
            } else {
              setisQrmode(true);
            }
          } else {
            console.log("'selectdeviceid'의 값이 null입니다.");
          }
    
          const postData = {
            verifierClubSeq: localStorage.getItem("clubNumber"),
            deviceId: localStorage.getItem("selectdeviceid"),
            method: "SELF-WAITING",
            longPeriod: false
          };
    
          console.log("입력값 : " + JSON.stringify(postData));
    
          const response = await fetch(`${API_BASE_URL_ISSUER}/presentation/verification/qrLinks`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(postData),
          });
    
          const data = await response.json();
          // console.log("(waitinput) PUT 요청 성공:", JSON.stringify(data.data));
          // console.log("qr 핀번호 : " + data.qrLinkPin);
          const jsonData = {
            "pin": data.data.qrLinkPin,
            "did": did,
            "method": "SELF-WAITING"
          };
    
          const jsonString = JSON.stringify(jsonData);
  
          // console.log("qr데이터 : " + JSON.stringify(jsonData));
          setqrdata(jsonString);
        } catch (error) {
          console.error("(waitinput) PUT 요청 실패:", error);
        }
      }

    };
    updateQRData();
    const intervalId = setInterval(updateQRData, 180000);
  
    return () => clearInterval(intervalId);
  }, [selectdeviceid]);
  // useEffect(() => {
  //   console.log("qr생성 ");

  //   const selectDeviceId = localStorage.getItem("selectdeviceid");
  //   if (selectDeviceId !== null) {
  //       const startsWithTmpDevice = selectDeviceId.startsWith("tmp_device");
  //       if (startsWithTmpDevice) {
  //           console.log("처음 값이 'tmp_device'로 시작합니다. (TRUE)");
  //           setisQrmode(true);
  //       } else {
  //           console.log("처음 값이 'tmp_device'로 시작하지 않습니다. (FALSE)");
  //           setisQrmode(false);
  //       }
  //   } else {
  //       console.log("'selectdeviceid'의 값이 null입니다.");
  //   }


  //   const postData = {
  //     verifierClubSeq: localStorage.getItem("clubNumber"),
  //     deviceId: localStorage.getItem("selectdeviceid"),
  //     method: "SELF-WAITING",
  //     longPeriod: true

  //   };

  //   console.log("입력값 : " + JSON.stringify(postData));
  //   try {
  //     fetch(`${API_BASE_URL_ISSUER}/presentation/verification/qrLinks`, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(postData),
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         console.log("(waitinput) PUT 요청 성공:", data.qrLinkPin);
  //         const jsonData = {
  //           "pin": data.qrLinkPin,
  //           "did": did
  //         };
  //         const jsonString = JSON.stringify(jsonData);
  //         setqrdata(jsonString)
  //       })

  //   } catch (error) {
  //     console.error("(waitinput) PUT 요청 실패:", error);
  //   }





  // }, [selectdeviceid]);
  useEffect(() => {
    console.log("맴버아이디 : " + memberid);
  }, [memberid]);

  useEffect(() => {
    const didValue = localStorage.getItem("did"); // Get value from localStorage
    const clubNumberValue = localStorage.getItem("clubNumber"); // Get value from localStorage
    const memberid = localStorage.getItem("selectmemberid"); // Get value from localStorage
    const selectedDeviceName = localStorage.getItem("selectedDeviceName"); // Get value from localStorage
    const selectmemberidsoket = localStorage.getItem("selectmemberidsoket"); // Get value from localStorage
    const selectdeviceid = localStorage.getItem("selectdeviceid");
    setselectdeviceid(selectdeviceid);
    setselectmemberidsoket(selectmemberidsoket)

    console.log("didValue : " + didValue)
    console.log("clubNumberValue : " + clubNumberValue)
    console.log("memberid : " + memberid)
    console.log("selectedDeviceName : " + selectedDeviceName)
    console.log("selectmemberidsoket : " + selectmemberidsoket)

    setDid(didValue);
    setClubNumber(clubNumberValue);
    setmemberid(memberid)
    setselectedDeviceName(selectedDeviceName)





  }, []); 

  useEffect(() => {

    fetchWaitMemberDataAPI();
  }, [clubNumber]);

  useEffect(() => {
    const rawToken = AuthService.getRawToken(); 
    // console.log("토큰~~!@@" + rawToken);
    settokendata(rawToken);
  }, [tokendata]);

  const waitbuttonClick = () => {
    const input1 = document.getElementById("input1") as HTMLInputElement;
    const input2 = document.getElementById("input2") as HTMLInputElement;
    const input3 = document.getElementById("input3") as HTMLInputElement;
    const phoneNumber = input1.value + input2.value + input3.value;
    console.log("phoneNumber.length" + phoneNumber.length)
    if (phoneNumber.length !== 11) {
      input1.value = "010";
      input2.value = "";
      input3.value = "";
      setIsConditionTrue("warning");
      setTimeout(() => {
        setIsConditionTrue("true");
      }, 3000);
      return;
    }
    console.log("did :", did);
    console.log("clubNumber:", clubNumber);
    console.log("phonenumber:", phoneNumber);
    console.log("token:", tokendata);

    const issuerDid = did;
    const clubSeq = clubNumber;
    const mobileNumber = phoneNumber;

    const output = {
      issuerDid: issuerDid,
      clubSeq: clubSeq,
      mobileNumber: mobileNumber,
      questionnaire: [",#,@" + selectedDeviceName]
    };
    console.log(
      "issuerdid: " +
      issuerDid +
      "/clubId: " +
      clubSeq +
      "/phonenumber : " +
      mobileNumber
    );

    console.log("Body : " + JSON.stringify(output, null, 2));
    console.log(`${API_BASE_URL}/club/agent/mobile/reception/waiting/add`)







    fetch(`${API_BASE_URL}/club/agent/mobile/reception/waiting/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokendata}`,
      },
      body: JSON.stringify(output, null, 2),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Success:", data);
        fetchWaitMemberDataAPI();
        setIsConditionTrue("false");

        // // 부모 창으로 데이터 전송
        //         const dataToSend = "가나다"; // 가나다 데이터 생성
        //         window.opener.postMessage(dataToSend, "http://localhost:3000/home");

        setTimeout(() => {
          setIsConditionTrue("true");
        }, 3000);
      })
      .catch((error) => {
        alert("Wait is not registered.");
        console.error("Error:", error);
      });

    input1.value = "010";
    input2.value = "";
    input3.value = "";

  };

  const handleNumberClick = (number: number) => {
    const input1 = document.getElementById("input1") as HTMLInputElement;
    const input2 = document.getElementById("input2") as HTMLInputElement;
    const input3 = document.getElementById("input3") as HTMLInputElement;

    if (input1 && input2 && input3) {
      const input1Value = input1.value;
      const input2Value = input2.value;
      const input3Value = input3.value;

      const combinedValue = input1Value + input2Value + input3Value;
      const totalLength = combinedValue.length;

      // Distribute the number to the appropriate input based on the length
      if (totalLength < 3) {
        input1.value += number;
      } else if (totalLength < 7) {
        input2.value += number;
      } else if (input3Value.length < 4) {
        input3.value += number;
      }
    }
  };


  const ClearClick = () => {
    console.log("Initialization");
    const input1 = document.getElementById("input1") as HTMLInputElement;
    const input2 = document.getElementById("input2") as HTMLInputElement;
    const input3 = document.getElementById("input3") as HTMLInputElement;

    input1.value = "010";
    input2.value = "";
    input3.value = "";
  };
  const DeleteClick = () => {
    console.log("Clear");
    const input1 = document.getElementById("input1") as HTMLInputElement;
    const input2 = document.getElementById("input2") as HTMLInputElement;
    const input3 = document.getElementById("input3") as HTMLInputElement;

    // Check and delete in reverse priority order (third, second, first)
    if (input3.value.length > 0) {
      input3.value = input3.value.slice(0, -1);
    } else if (input2.value.length > 0) {
      input2.value = input2.value.slice(0, -1);
    } else if (input1.value.length > 0) {
      input1.value = input1.value.slice(0, -1);
    }
  };





  return (

    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>

      <div style={{ flex: 1, backgroundColor: "white" }}>

        <div style={{ display: "flex", height: "100vh", width: "100%" }}>
          <div
            style={{
              flex: 1,
              backgroundColor: "white",
              display: "flex",
              overflowY: "hidden",
              flexDirection: "column",
              height: "100%",
              width: "100%"

            }}>
            <div style={{ backgroundColor: '#123758', fontSize: "1vw", display: "flex", alignItems: "center", justifyContent: "space-between", textAlign: "left", color: "white", width: "100%", height: "7%", padding: "10px" }}>
              {clubName} - {selectedDeviceName}
            </div>

            {isConditionTrue === "true" ? (
              <div
                style={{
                  flex: 1,
                  borderBottom: "2px solid black",
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "100%"
                }}
              >
                <div style={{ fontSize: "3vw", textAlign: "center", width: "100%", height: "100%" }}>
                  전화번호로 등록하세요

                  <div style={{ fontSize: "3vw", textAlign: "center", width: "100%", height: "100%" }}>
                    <br />
                    현재 대기 수 : [{contentLength}]
                  </div>

                </div>

                {isQrmode ? (
                                    <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "30%",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    id="input1"
                    name="input1"
                    style={{
                      width: "calc(33.33% - 10px)", // Divide by 3 with spacing
                      height: "100%",
                      fontSize: "3vw",
                      textAlign: "center",
                      letterSpacing: "1.5vw",
                      marginRight: "10px", // Add some spacing between inputs
                    }}
                    readOnly
                    defaultValue="010"
                  />
                  <div style={{ fontSize: "3vw", marginRight: "10px" }}>-</div>
                  <input
                    type="text"
                    id="input2"
                    name="input2"
                    style={{
                      width: "calc(33.33% - 10px)", // Divide by 3 with spacing
                      height: "100%",
                      fontSize: "3vw",
                      textAlign: "center",
                      letterSpacing: "1.5vw",
                      marginRight: "10px", // Add some spacing between inputs
                    }}
                    readOnly
                    placeholder="0000"
                  />
                  <div style={{ fontSize: "3vw", marginRight: "10px" }}>-</div>
                  <input
                    type="text"
                    id="input3"
                    name="input3"
                    style={{
                      width: "calc(33.33% - 10px)", // Divide by 3 with spacing
                      height: "100%",
                      fontSize: "3vw",
                      textAlign: "center",
                      letterSpacing: "1.5vw",
                    }}
                    readOnly
                    placeholder="0000"
                  />
                </div>
                ):(
                  <div>

                  </div>
                )}


              </div>



            ) : isConditionTrue === "false" ? (
              <div
                style={{
                  flex: 1,
                  borderBottom: "2px solid black",
                  backgroundColor: "#9DD84B",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center", // Center vertically
                  alignItems: "center", // Center horizontally
                  height: "50%"
                }}
              >

                <div style={{ fontSize: "3vw", textAlign: "center", }}>
                  대기 등록을 완료했습니다
                  <br />
                  {/* 대기번호 : 25  */}
                  <br />
                  남은 대기순번 : {contentLength}
                </div>


              </div>
            ) : isConditionTrue === "warning" ? (
              <div
                style={{
                  flex: 1,
                  borderBottom: "2px solid black",
                  backgroundColor: "#FFD400",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center", // Center vertically
                  alignItems: "center", // Center horizontally
                  height: "50%",
                }}
              >
                <div style={{ fontSize: "3vw", textAlign: "center" }}>
                  전화번호를 모두입력해주세요

                </div>
              </div>
            ) : (
              <div
                style={{
                  flex: 1,
                  borderBottom: "2px solid black",
                  backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center", // Center vertically
                  alignItems: "center", // Center horizontally
                  height: "50%",
                }}
              >
                <div style={{ fontSize: "100%", textAlign: "center" }}>
                  네트워크 에러입니다 관리자에게 연락하세요.
                </div>
              </div>
            )}




            <div
              style={{
                flex: 1,
                backgroundColor: "white",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "50%",
                width: "100%",
                justifyContent: "center",
              }}
            >
              {isQrmode ? (

              <div>
                <QRCode value={qrdata} size={400} />
              </div>
              ):(
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "30%",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    id="input1"
                    name="input1"
                    style={{
                      width: "calc(33.33% - 10px)", // Divide by 3 with spacing
                      height: "100%",
                      fontSize: "3vw",
                      textAlign: "center",
                      letterSpacing: "1.5vw",
                      marginRight: "10px", // Add some spacing between inputs
                    }}
                    readOnly
                    defaultValue="010"
                  />
                  <div style={{ fontSize: "3vw", marginRight: "10px" }}>-</div>
                  <input
                    type="text"
                    id="input2"
                    name="input2"
                    style={{
                      width: "calc(33.33% - 10px)", // Divide by 3 with spacing
                      height: "100%",
                      fontSize: "3vw",
                      textAlign: "center",
                      letterSpacing: "1.5vw",
                      marginRight: "10px", // Add some spacing between inputs
                    }}
                    readOnly
                    placeholder="0000"
                  />
                  <div style={{ fontSize: "3vw", marginRight: "10px" }}>-</div>
                  <input
                    type="text"
                    id="input3"
                    name="input3"
                    style={{
                      width: "calc(33.33% - 10px)", // Divide by 3 with spacing
                      height: "100%",
                      fontSize: "3vw",
                      textAlign: "center",
                      letterSpacing: "1.5vw",
                    }}
                    readOnly
                    placeholder="0000"
                  />
                </div>
              )}

              
            </div>
          </div>
          <div
            style={{
              flex: 1,
              borderLeft: "2px solid black",

              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
              width: "100%",
              justifyContent: "center", // Center content vertically
            }}
          >
            {/* Right Pane Content (Keypad) */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Buttons */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "10px",
                  height: "100%",
                  width: "100%",
                }}
              >
                {/* Buttons */}
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(1)}>1</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(2)}>2</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(3)}>3</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(4)}>4</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(5)}>5</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(6)}>6</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(7)}>7</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(8)}>8</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(9)}>9</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={ClearClick}>Reset</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={() => handleNumberClick(0)}>0</button>
                <button style={{ width: "100%", height: "100%", fontSize: "4vw" }} onClick={DeleteClick}>Clear</button>

              </div>
            </div>
            <div style={{ width: "100%", height: "20%", margin: "10px" }}>
              <button
                style={{ width: "100%", height: "100%", fontSize: "4vw" }}
                onClick={waitbuttonClick}
              >
                등록완료
              </button>
            </div>
          </div>

        </div>


      </div>



    </div>
  );

};

export default Waitinput;